import { RecipesApiResponse } from '../types/recipes';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://bagr.iprosystems.com/api';
const API_KEY = import.meta.env.VITE_API_KEY;

/**
 * Fetches recipes from the API
 */
export async function fetchRecipes(): Promise<RecipesApiResponse> {
  const url = new URL(`${API_BASE_URL}/recipes`);
  url.searchParams.append('populate', '*');
  url.searchParams.append('sort', 'createdAt:desc');
  url.searchParams.append('pagination[limit]', '2000');

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  if (API_KEY) {
    headers['Authorization'] = `Bearer ${API_KEY}`;
  }

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch recipes: ${response.status} ${response.statusText}`);
  }

  return response.json();
}



